// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__r5tEx","title":"styles_title__AMZpk"};